import flexslider from "flexslider";

export default function(){
    $(document).ready(function(){
        $('.js-slider').flexslider({
            animation: "Slide",
            nextText: "<span class='sr-only'>Next</span>",
            prevText: "<span class='sr-only'>Previous</span>",
        });
        $('.js-product-slider').flexslider({
            animation: "Slide",
            conrolsContainer: '.js-gallery-thumbnails',
            controlNav: true,
            directionNav: false,
            manualControls: '.js-gallery-thumbnails li',
            smoothHeight: true,
            touch: true,
        });
    });
}
